import { Switch } from "antd";
import { SwitchSize } from "antd/lib/switch";
import classNames from "classnames";
import styles from "./index.module.less";

export function AigcSwitch({
  disabled,
  originAigc,
  value,
  onChange,
  className,
  ref,
  size = "small",
}: {
  disabled?: boolean;
  originAigc?: number;
  value?: boolean;
  onChange?: (value: boolean) => void;
  className?: string;
  ref?: React.RefObject<HTMLDivElement>;
  size?: SwitchSize;
}) {
  return (
    <div ref={ref} className={className}>
      <div className={classNames(styles.aigcSwitch)}>
        <Switch
          size={size}
          disabled={disabled}
          checked={value}
          onChange={onChange}
        />
        <div
          className={classNames(styles.aigcSwitchText, {
            [styles.disabled]: disabled,
          })}
        >
          含 AI 生成内容
        </div>
      </div>
      {value && (
        <div className={styles.aigcTip}>
          {originAigc === 2
            ? "不支持关闭，可联系客服获取帮助"
            : originAigc === 1
            ? "检测到 AI 标识，将按国家法规进行提示"
            : "开启后，将按国家法规要求添加 AI 标识"}
        </div>
      )}
    </div>
  );
}
